<template>
  <div>
    <Main ref="main" :loading="loading" :tableData="tableData"> </Main>
  </div>
</template>
<script>
import Main from './main'
import EditLoading from '@/mixins/edit-loading'
export default {
  mixins: [EditLoading],
  components: { Main },
  props: { orderTechDocCode: { type: String, default: '' } },
  data() {
    return {
      loading: false,
      tableData: [],
    }
  },
  mounted() {
    this.getData()
  },
  methods: {
    getData() {
      console.log('orderTechDocCode >>', this.orderTechDocCode)
      if (!this.orderTechDocCode) return
      this.loading = true
      this.$api
        .pendingOrderTechDocSpecListApi({
          orderTechDocCode: this.orderTechDocCode,
        })
        .then((res) => {
          this.loading = false
          this.tableData = res.body.data
        })
    },
  },
}
</script>
